/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocsSearchResult } from '../../models/docs-search-result';

export interface ApiDocsSearchGet$Params {

/**
 * Free-text search query (e.g. "create webhook tool").
 */
  query?: string;

/**
 * Language locale: `ru` (default) or `en`.
 */
  locale?: string;
}

export function apiDocsSearchGet(http: HttpClient, rootUrl: string, params?: ApiDocsSearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DocsSearchResult>> {
  const rb = new RequestBuilder(rootUrl, apiDocsSearchGet.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('locale', params.locale, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocsSearchResult>;
    })
  );
}

apiDocsSearchGet.PATH = '/api/Docs/search';
